export enum ProjectAuthMethodId {
    Emailpassword = 'email-password',
    Magicurl = 'magic-url',
    Emailotp = 'email-otp',
    Anonymous = 'anonymous',
    Invites = 'invites',
    Jwt = 'jwt',
    Phone = 'phone',
    Passkey = 'passkey',
}
